export interface ReviewerComment {
  id: number;
  location: string;
  text?: string;
  comment: string;
}

export interface Reviewer {
  label: string;
  name: string;
  affiliation: string;
  comments: ReviewerComment[];
}

export interface PatientData {
  patientId: number;
  reportId: number;
  label: string;
  content: string;
  reviewers: Reviewer[];
}


// ── 정적 약품 데이터 (API 호출 불필요) ──
export interface StaticDrugInfo {
  productName: string;
  chart: string;
  printFront: string;
  printBack: string;
}

export const staticDrugData: Record<string, StaticDrugInfo> = {
  "196000011": { productName: "페니라민정(클로르페니라민말레산염)", chart: "미황색의 원형 정제", printFront: "YH", printBack: "" },
  "196400037": { productName: "라식스정(푸로세미드)", chart: "백색 원형 정제임.", printFront: "DLI분할선DLI", printBack: "" },
  "197500541": { productName: "구주스피로닥톤정(스피로노락톤)", chart: "미황색 원형의 필름코팅정제", printFront: "S25", printBack: "" },
  "197900543": { productName: "아티반정0.5밀리그람(로라제팜)", chart: "황색 정제", printFront: "ID·5", printBack: "분할선" },
  "197900575": { productName: "슈다페드정(슈도에페드린염산염)", chart: "흰색의 원형 정제", printFront: "마크분할선SD", printBack: "" },
  "198500125": { productName: "시그마트정5밀리그램(니코란딜)", chart: "백색 원형의 정제", printFront: "마크", printBack: "5분할선S" },
  "198500436": { productName: "엠코발500마이크로그램캡슐(메코발라민)", chart: "적색 반점이 있는 흰색 가루의 적색 경질캡슐제", printFront: "D-W MCB", printBack: "" },
  "198901206": { productName: "알말정5밀리그램(아로티놀롤염산염)", chart: "흰색의 원형 필름코팅정", printFront: "INO", printBack: "A5" },
  "199700059": { productName: "록스펜정(록소프로펜나트륨)", chart: "흰색의 원형정제", printFront: "S분할선P", printBack: "LOX" },
  "199802244": { productName: "몰시톤정4밀리그램(몰시도민)", chart: "연분홍색의 원형정제", printFront: "M4", printBack: "분할선" },
  "199802384": { productName: "신일엠정(수산화마그네슘)", chart: "흰색의 원형정제", printFront: "M", printBack: "SIL" },
  "199900351": { productName: "레날민정", chart: "노란색의 타원형 필름코팅정", printFront: "ID r", printBack: "" },
  "200008764": { productName: "콩코르정5밀리그램(비소프롤롤푸마르산염)", chart: "미황색 심장형 필름코팅정제", printFront: "분할선", printBack: "분할선" },
  "200101738": { productName: "훼로바-유서방정(건조황산제일철)", chart: "담갈색의 원형 필름코팅정", printFront: "마크", printBack: "FER" },
  "200108429": { productName: "아스피린프로텍트정100밀리그람", chart: "흰색의 원형 장용 필름코팅정", printFront: "Bayer", printBack: "" },
  "200300921": { productName: "보령레바미피드정100밀리그램", chart: "흰색의 원형 필름코팅정", printFront: "BR", printBack: "" },
  "200307976": { productName: "바스티난엠알서방정(트리메타지딘염산염)", chart: "분홍색 필름코팅정제", printFront: "마크", printBack: "" },
  "200409929": { productName: "알닥톤필름코팅정25밀리그람(스피로노락톤)", chart: "미황색 원형의 필름코팅정제", printFront: "SEARLE39", printBack: "" },
  "200410067": { productName: "디오반필름코팅정40밀리그램(발사르탄)", chart: "황색의 타원형 필름코팅정", printFront: "D분할선O", printBack: "NVR" },
  "200410869": { productName: "자낙스정0.25밀리그램(알프라졸람)", chart: "백색의 타원형 정제", printFront: "XANAX0.25", printBack: "분할선" },
  "200511068": { productName: "졸로푸트정50밀리그람(설트랄린염산염)", chart: "흰색 캡슐모양 필름 코팅정", printFront: "마크", printBack: "ZLT분할선50" },
  "200610884": { productName: "리보트릴정(클로나제팜)", chart: "엷은 주황색의 원형 정제", printFront: "0,5", printBack: "분할선" },
  "200610962": { productName: "다이아민엑스알서방정(메트포르민염산염)", chart: "흰색의 장방형 서방정", printFront: "DK5", printBack: "" },
  "200700634": { productName: "스틸녹스정10밀리그램(졸피뎀타르타르산염)", chart: "백색 장방형의 필름코팅제", printFront: "STILNOX", printBack: "분할선" },
  "200700907": { productName: "플라빅스정75밀리그램(클로피도그렐황산염)", chart: "분홍색의 원형필름코팅정", printFront: "75", printBack: "1171" },
  "200708961": { productName: "덱시펜정(덱시부프로펜디.씨)", chart: "분홍색 장방형의 필름코팅정", printFront: "NGP", printBack: "DEX" },
  "200906484": { productName: "보령바이오아스트릭스캡슐100밀리그램(아스피린장용과립)", chart: "상하 주황색의 투명한 경질캡슐제", printFront: "ASTX 100", printBack: "" },
  "201001003": { productName: "슈스타정5밀리그램(로수바스타틴칼슘)", chart: "노란색의 원형 필름코팅정", printFront: "AG", printBack: "C5" },
  "201002151": { productName: "다이아벡스엑스알서방정1000밀리그램(메트포르민염산염)", chart: "흰색의 타원형 서방정", printFront: "SR 1000", printBack: "" },
  "201102775": { productName: "메게이스내복현탁액(메게스트롤아세테이트)", chart: "", printFront: "", printBack: "" },
  "201108203": { productName: "렌벨라정(세벨라머탄산염)", chart: "백색-회백색의 타원형 필름코팅정", printFront: "RENVELA800", printBack: "" },
  "201201792": { productName: "두타리드연질캡슐(두타스테리드)", chart: "무색 투명 내용물의 미황색 타원형 연질캡슐", printFront: "DCDU", printBack: "" },
  "201206820": { productName: "경보아스피린장용정", chart: "흰색의 원형 장용성 필름코팅정", printFront: "KbAS", printBack: "" },
  "201211097": { productName: "듀락칸이지시럽(락툴로오즈농축액)", chart: "", printFront: "", printBack: "" },
  "201305918": { productName: "엘리퀴스정5밀리그램(아픽사반)", chart: "분홍색의 달걀형 필름코팅정", printFront: "5", printBack: "894" },
  "201310308": { productName: "포시가정10밀리그램(다파글리플로진)", chart: "노란색의 다이아몬드형 필름코팅 정제", printFront: "10", printBack: "1428" },
  "201400403": { productName: "환인클로나제팜정0.5밀리그램", chart: "엷은 주황색의 원형 정제", printFront: "WI0.5", printBack: "분할선" },
  "201402959": { productName: "글로아스피린장용정100mg(아스피린)", chart: "흰색의 원형 장용성 필름코팅정", printFront: "KG", printBack: "7" },
  "201404483": { productName: "솔리신정5mg(솔리페나신숙신산염)", chart: "밝은 노란색 원형 필름코팅정제", printFront: "마크", printBack: "5" },
  "201501710": { productName: "부광로수바스타틴칼슘정10밀리그램", chart: "분홍색의 원형 필름코팅정", printFront: "마크", printBack: "CR10" },
  "201507502": { productName: "에소젠정40밀리그램(에스오메프라졸마그네슘이수화물)", chart: "분홍색의 원형필름코팅정", printFront: "EG4", printBack: "" },
  "201603089": { productName: "모사프로진정(모사프리드시트르산염수화물)", chart: "흰색의 장방형 필름코팅정", printFront: "IC", printBack: "M분할선5" },
  "201603377": { productName: "비보존탐스로신서방정0.2mg(탐스로신염산염)", chart: "흰색의 원형 필름코팅정", printFront: "TN2", printBack: "" },
  "201706786": { productName: "유니베포타정(베포타스틴베실산염)", chart: "흰색 원형의 필름코팅정", printFront: "UKT", printBack: "분할선" },
  "201707657": { productName: "네비스톨정1.25밀리그램(네비보롤염산염)", chart: "흰색의 원형 정제", printFront: "EL1", printBack: "" },
  "201602112": { productName: "엔트레스토필름코팅정100밀리그램(사쿠비트릴·발사르탄)", chart: "연노란색의 타원형 필름코팅정", printFront: "L1", printBack: "NVR" },
  "202002185": { productName: "셀콕스캡슐100밀리그램(세레콕시브)", chart: "상하 푸른색 줄이 있는 흰색의 캡슐제", printFront: "MK 100", printBack: "" },
  "202101478": { productName: "미라베서방정50밀리그램(미라베그론)", chart: "노란색의 타원형 필름코팅 서방정", printFront: "MK", printBack: "50" },
  "HFF2007001800116": { productName: "고려홍삼정골드", chart: "", printFront: "", printBack: "" },
  "HFF202300268662": { productName: "원광모아철캡슐", chart: "", printFront: "", printBack: "" },
};

// ── 개요 페이지 데이터 ──
export interface OverviewStep {
  label: string;
  description: string;
}

export interface OverviewPerspective {
  perspective: string;
  question: string;
}

export interface OverviewGuideItem {
  element: string;
  description: string;
}

export interface OverviewSection {
  heading: string;
  content?: string;
  items?: string[];
  steps?: OverviewStep[];
  perspectives?: OverviewPerspective[];
  guideItems?: OverviewGuideItem[];
}

export interface OverviewData {
  title: string;
  subtitle: string;
  sections: OverviewSection[];
}

export const overviewData: OverviewData = {
  title: "AI 복약지도문 전문가 검수 사례집",
  subtitle: "☝️ PhAI가 생성한 복약지도문을 임상약학 교수님과 다제·방문약료 경험이 풍부한 약사분들이 검수한 기록이에요.",
  sections: [
    {
      heading: "왜 AI가 만든 복약지도문을 검수해야 하나요?",
      content: "AI 복약지도문은 편리하지만, 그대로 사용하면 안 돼요.",
      items: [
        "환자에게 불안을 줄 수 있는 표현이 포함될 수 있어요",
        "환자가 조절할 수 없는 내용(처방 변경 등)이 섞여 나올 수 있어요",
        "성별·연령에 맞지 않는 정보가 출력되기도 해요",
      ],
    },
    {
      heading: "그래서 전문가 자문을 진행했어요",
      content: "PhAI 개발팀은 AI가 놓치는 부분을 체계적으로 파악하기 위해, 임상약학 교수님과 다제·방문약료 경험이 풍부한 약사분들께 자문을 요청했어요. 원래는 PhAI가 더 완벽한 복약지도문을 만들게 하기 위한 자문이었지만, AI를 사용하시는 약사님들도 꼭 참고하셔야 할 실전 코멘트가 많이 나왔어요. 그래서 이 내용을 다른 약사님들도 보실 수 있도록 이 사이트에 정리했어요.",
    },
    {
      heading: "자문 과정",
      steps: [
        { label: "PhAI 생성", description: "환자케이스 4건에 대해 복약지도문 + 의사 자문 서한을 PhAI로 생성했어요" },
        { label: "독립 검토", description: "5분의 약사가 각자 \"현장에서 이대로 쓸 수 있는가\"를 기준으로 첨삭했어요" },
        { label: "의견 취합", description: "약사별 코멘트를 환자·항목 단위로 모았어요" },
        { label: "합동 토론", description: "의견이 갈린 핵심 쟁점 4건에 대해 합동 토론을 진행했어요" },
        { label: "결과 정리", description: "토론 결과와 PhAI 개선 방향을 이 사이트에 정리했어요" },
      ],
    },
    {
      heading: "베테랑 약사들이 공통으로 본 관점",
      perspectives: [
        { perspective: "환자 불안", question: "이 문구를 읽은 환자가 불안해하지 않을까요?" },
        { perspective: "실천 가능성", question: "환자가 직접 할 수 있는 내용인가요, 의사만 할 수 있는 건가요?" },
        { perspective: "근거 수준", question: "이 상호작용은 임상적으로 유의미한가요?" },
        { perspective: "허가 vs 관행", question: "허가사항은 1일 3회인데 현장에서는 1일 1회예요. 지적해야 할까요?" },
        { perspective: "전달 대상", question: "이건 환자에게 말할 내용인가요, 의사에게 보낼 내용인가요?" },
        { perspective: "표현 적절성", question: "환자가 이 단어를 이해할 수 있나요?" },
      ],
    },
    {
      heading: "이 사이트 사용법",
      guideItems: [
        { element: "환자 1~4 탭", description: "각 환자의 PhAI 출력물 원문과 약사 코멘트를 함께 볼 수 있어요" },
        { element: "A~E 토글", description: "약사별로 코멘트를 켜고 끌 수 있어요. 각 약사의 관점을 비교해 보세요" },
        { element: "★ 표시", description: "약사 간 의견이 갈린 핵심 쟁점이에요. 토론 주제 탭에서 결과를 확인하세요" },
        { element: "토론 주제 탭", description: "핵심 쟁점의 토론 결과와 PhAI 출력 원칙 합의 사항을 정리했어요" },
      ],
    },
  ],
};

export interface DiscussionItem {
  label: string;
  question: string;
  quote?: string;
  result?: string;
}

export interface DiscussionTopic {
  title: string;
  items: DiscussionItem[];
}

export const discussionTopics: DiscussionTopic[] = [
  {
    title: "★ 환자별 핵심 쟁점 토론 결과",
    items: [
      {
        label: "[환자1] 처방연쇄 — 환자에게 부작용 원인약을 알려야 하나?",
        quote: "알말정(혈압·떨림약)은 갑자기 끊지 말고, 숨이 차거나 다리가 더 붓는다면 바로 연락해 주세요",
        question: "트리메타지딘 → 손떨림 → 알말정 추가 처방. 환자에게 부작용 원인약을 직접 알려야 하는지, 의사를 통해 전달해야 하는지?",
        result: "【의견 분포】\n자문위원4: 알려야 한다(환자 알 권리). 단, 의사에게도 별도 전달 필요.\n자문위원3: 알리지 않는 것이 낫다. 대안 없는 정보는 복약이행도를 오히려 저하시킨다. 환자 임의 중단 위험.\n자문위원5: 의사에게 먼저. 오프라벨 사용 가능성이 있고, 의사와 소통 후 환자 안정화가 우선. 단, 횡문근융해증 등 긴급 시에는 즉시 응급실 안내.\n자문위원2: 의사를 통해 전달. 공단 전산 의견란 + 출력물로 의사에게 전달하는 방식 활용 중.\n\n자문위원1: \"거꾸로 알말정 처방의에게 바스티난MR 때문에 떨림이 생겼을 가능성을 알려야 하는 상황.\" 방향이 중요 — 원인약 처방의가 아니라 결과약 처방의에게 전달. 환자에게는 \"드신 후 손떨림이 있음을 의사에게 알려 주십시오\" 또는 \"약물 조정으로 떨림 증상이 조절되면 지속 여부를 의사와 상의하세요\" 수준.\n\n【결론】 트리메타지딘-파킨슨 떨림은 처방 연쇄보다 질병 금기(disease contraindication) 수준. 환자용에는 간접적으로만 기재하고, 의사용 서한에 명확히 기재한다.",
      },
      {
        label: "[환자2] 근거 수준 낮은 상호작용 — 홍삼+아스피린 출혈 위험",
        quote: "홍삼 제품과 아스피린을 함께 드실 때는 멍이나 출혈이 늘어날 수 있어 주의가 필요합니다",
        question: "건강기능식품의 기능성 문구(\"혈소판 억제를 통한 혈액 흐름 도움\")를 근거로 출혈 주의를 안내했으나, 근거 수준이 낮다는 의견이 있었다.",
        result: "【합의】 줘도 된다. 단, 표현 강도를 낮추고 \"과도하게 드실 경우\" 등 정도를 제한하는 수식어 사용.\n\n자문위원1: \"과도하게 먹을 때 그렇다라는 말을 써 주면 될 것 같다.\"\n자문위원4: \"간헐적 복용은 문제 없지만 대량 지속 복용하는 분이 있어 주의사항 정도로 알리는 것 필요.\"\n자문위원5: \"꾸준히 복용했다면 계속, 불규칙하게 하지만 않으면 괜찮다.\"\n자문위원2: \"아스피린 복용자에게는 홍삼 외에도 오메가3, 은행나무추출물 등 출혈 영향 건기식을 포괄적으로 교육하는 기회로 활용.\"\n\n【결론】 근거 수준 낮은 상호작용도 \"주의사항\" 수준으로 제공하되, 단정적 표현(\"금기\", \"위험\") 대신 조건부 표현(\"과도하게 드실 경우\") 사용.",
      },
      {
        label: "[환자3] 환자용/의사용 구분 원칙 — 플라빅스+에소메프라졸",
        quote: "에소젠40(에스오메프라졸)과 함께 드시면 플라빅스의 효과가 약해질 수 있습니다. 다음 진료 때 꼭 말씀해 주세요.",
        question: "에소메프라졸-클로피도그렐 상호작용을 환자용에 포함할지, 의사 서한에만 포함할지?",
        result: "자문위원1: \"환자 안내문에는 정말 환자가 주의해야 할 것, 환자가 모니터링해서 알릴 것만 출력하게 하면 지금의 문제가 다 없어질 것 같다. 건기식, 일반약은 환자가 조절할 수 있으니까 알려주면 되고, 처방 변경이 필요한 것은 환자가 할 수 없으므로 의사 전달 안내문을 출력해서 보낸다는 프로시저를 명확히 하면 깔끔하다.\"\n\n자문위원2: \"환자에게는 다른 병원 갈 때 위장약 먹고 있다고 항상 말씀하라고 교육.\"\n자문위원5: \"환자에게 불안해할 수 있는 내용은 빼고, 병원용은 세밀하게 출력.\"\n자문위원4: \"전문 용어로 환자가 알아보지 못하게 써서 의사에게 전달하는 방법도 가능.\"\n\n【결론 — PhAI 핵심 원칙 확정】\n• 환자용 = 환자가 직접 실천/조절 가능한 것만 (투약 간격, 건기식/OTC 주의, 증상 모니터링)\n• 의사용 = 처방 변경이 필요한 모든 것 (약물 상호작용 회피, 용량 조정, 대체약물 제안)",
      },
      {
        label: "[환자4] 메게스테롤 — 허가 외 사용 약물의 안내 방식",
        quote: "메게스트롤은 부신억제/고혈당/혈전 등 위험이 있어 고령자에서 위해-유익 재평가가 필요해 보입니다.",
        question: "메게스테롤 관련 문구를 AI가 자동 출력해야 하는지, 약사가 판단해야 하는 영역인지?",
        result: "자문위원2: \"허가사항에 해당 없어도 식욕 촉진 목적으로 빈번하게 사용. 보호자 눈치도 보이고 어떻게 얘기할지 고민.\"\n자문위원5: \"의사들도 다 안다. 한 통(7정) 정도는 넘어가고, 2~3개월 지속 시 연락.\"\n자문위원3: \"지속 처방이 대부분. 의사 판단 필요한 항목이므로 약사가 판단해서 넣어야 한다.\"\n\n자문위원1: \"약사가 '판단 필요'라는 표시를 하나 넣어서 선택적으로 포함할 수 있게 하면 좋겠다. 식욕 부진이 더 중요한 환자도 있고, 위험성이 더 중요한 환자도 있으므로 개별화 필요.\"\n자문위원4: \"환자용에는 복용 중 고혈당이나 새로운 증상 발생 시 의사에게 바로 알리라는 문구 정도.\"\n\n【결론】 AI 자동 출력 대신 \"약사 판단 필요\" 플래그로 약사가 선택적 포함 여부를 결정. 환자용에는 안전 문구(\"새로운 증상 시 의사에게 알릴 것\")만.",
      },
    ],
  },
  {
    title: "의사용 서한 — 대체약물 제시 수위",
    items: [
      {
        label: "대체약물을 어디까지 구체적으로 제시해야 하나?",
        question: "의사에게 '위장약을 다른 약으로 바꿔주세요'라고 두루뭉술하게 말하는 것과 특정 대체 약물을 명시적으로 제안하는 방식 중 어느 쪽이 현장 수용률이 높은가?",
        result: "자문위원5: \"전문의도 자기 전공 외 약은 잘 모른다. 제품명+성분명으로 제안하면 오히려 고마워한다. 단, 치매·정신과 등 복잡한 분야는 '처방 검토 부탁드립니다' 수준으로.\"\n자문위원3: \"항상 대안을 주는 편. '아세트아미노펜이 심혈관 부담이 적습니다. 참고해 주세요.' 수준으로 중립적이고 드라이하게.\"\n자문위원2: \"구체적 약물명, 용법, 횟수 없으면 하나마나한 얘기. 단 에비던스 없으면 절대 말할 수 없다.\"\n\n자문위원1: \"에비던스 명확한 경우(협심증 + COX → 아세트아미노펜/트라마돌)는 제시 가능. 정신과약은 콕 집기 어렵다. '식욕 저하 부작용이 있는 약 vs 뉴트럴한 약' 정보 수준이 현실적. 불면에서는 트라조돈 전환 가능하다는 팩트 정도.\"\n\n【결론】\n• 에비던스 명확: 제품명+성분명 구체적 제시\n• 에비던스 있으나 복잡(정신과, 치매): 약물 특성 정보 수준 (부작용 프로필 비교)\n• 에비던스 불분명: \"처방 검토 부탁드립니다\" 수준\n• 표현 톤: 중립적 정보 전달 방식이 현장 수용률 높음",
      },
    ],
  },
  {
    title: "복약지도문 포맷 및 활용도 피드백",
    items: [
      {
        label: "현재 포맷에 대한 약사진 평가",
        question: "환자용 복약지도문과 의사용 서한의 현재 포맷이 현장에서 실제로 활용할 만한가?",
        result: "자문위원5: \"PhAI 없었으면 이 많은 건을 하기 힘들었겠다. 현재 포맷 만족. 이전에는 타 AI 3종 돌려서 편집하는 데 시간이 매우 많이 들었다.\"\n자문위원2: \"이게 없었을 시절에 어떻게 상담을 준비했을까 싶을 정도. 방문 후 재정리해서 다시 드리고 싶은 니즈가 있다.\"\n자문위원3: \"처음 봤을 때 길지만 보기 싫지 않다. 그림이 있어서 흥미를 끌고, 약 사진이 크게 나오는 것이 좋다.\"\n자문위원4: \"전체 제공하지 않고 편집해서 핵심 1~2가지만 현장에서 전달. 방문 시 환자 상황에 따라 또 달라진다.\"\n\n자문위원1: \"복약지도 항목 내 약 그림은 없어도 될 수 있다(앞에 약 목록에서 이미 제공). 특정 약을 그림으로 지목하면 환자가 '이 약 때문'이라고 할 수 있는 우려. 편집 가능하면 별 문제 없다. 항상 지우게 되는 항목이 있다면 디폴트 설정 변경이 더 편리.\"",
      },
      {
        label: "항목 수와 정보량",
        question: "환자용 복약지도문이 5~7개 항목인데, 현장에서 어르신에게 전달할 때 적정선은?",
        result: "약사들의 공통 패턴: 전체를 출력해서 준비하되, 현장에서는 핵심 1~2가지만 추려서 전달. 나머지는 약사 본인이 숙지하고 가는 용도.\n\n자문위원2: \"준비하는 약사 입장에서는 다 숙지하고 가는 게 맞다. 가져가서 안 맞으면 보충하거나, 방문 후 재정리해서 재제공.\"\n자문위원4: \"환자에게 다 전달하지 않고 상황에 맞는 것만 골라서.\"\n\n【결론】 항목 수 자체를 줄이는 것보다, 약사가 현장에서 선택적으로 전달할 수 있는 구조 유지. 단, 방문 후 수정본을 카톡으로 보낼 수 있는 기능이 필요.",
      },
      {
        label: "현장 워크플로우와 개선 요청",
        question: "PhAI 복약지도문의 실제 활용 방식과 추가로 필요한 기능은?",
        result: "【현장 워크플로우 공통 패턴】\n① 준비: PhAI로 복약지도문 생성 → 사전 검토/편집 → 환자용+병원용 인쇄\n② 방문: 1차 방문 → 절반은 맞고 절반은 최근 자료 미반영으로 수정 필요\n③ 후속: 수정 후 다음날 카톡/문자 전송 (현재 수동)\n\n【주요 기능 요청】\n• 현재 복용약 목록 편집 가능 별도 출력 (의사 방문 시 제출용)\n• 약명 옆 효능군 1줄 표기 (공단 주성분군 활용)\n• 방문 후 수정본 PDF 카톡 전송 기능\n• 약사 수정 이력 로그 → 학습 데이터화\n• 성별 필터링 (여성 환자에게 발기부전 정보 자동 제거)\n• 가루약 조제 불가 약물 경고, 연하곤란 환자 알약 크기 정보\n\n자문위원5: \"PhAI만 믿지 않고 다른 AI로 교차 검증한다. 3~4개월 전 결과와 현재가 다르게 나오는 경우도 있어 항상 의심하면서 정확한 정보 전달에 노력 필요. 이건 혼자만 소유하지 말고 공유해서 모든 약사님들이 상향 평준화됐으면 좋겠다.\"",
      },
    ],
  },
];

export const patients: PatientData[] = [
  {
    patientId: 1389,
    reportId: 3146,
    label: "환자 1",
    content: `<badge>💊 약 복용 시 특히 주의해야 할 점</badge>
# 1. 아스트릭스캡슐(아스피린)을 드시는 동안 멍·코피·검은 변이 보이면 알려주세요
- 피를 묽게 하는 약으로 출혈 가능성이 있습니다. 치과·시술 전에는 복용 사실을 꼭 말씀해 주세요.
⑆img_200906484

# 2. 시그마트정(협심증약)은 하루 3번이 필요할 수 있어요. 발기부전약과는 함께 드시면 안 됩니다
- 현재 하루 2번으로 처방되어 있으나 증상에 따라 하루 3번이 필요할 수 있어 다음 진료 때 상의해 주세요. 발기부전약(PDE5)은 함께 복용하면 위험하므로 복용 중이면 꼭 알려주세요.
⑆img_198500125

# 3. 바스티난엠알서방정(협심증약)을 드시는 중에 손떨림이 지속되면 꼭 말씀해 주세요
- 이 약은 떨림(파킨슨 증상 포함)이 있는 분에게는 맞지 않을 수 있습니다. 임의로 중단하지 말고, 증상 변화를 기록해 다음 진료 때 알려주세요.
⑆img_200307976

# 4. 알말정(혈압·떨림약)은 갑자기 끊지 말고, 숨이 차거나 다리가 더 붓는다면 바로 연락해 주세요
- 이 약은 갑자기 끊으면 위험할 수 있어요. 증상이 있으면 의사와 상의하여 서서히 조절합니다.
⑆img_198901206

# 5. 알닥톤정(이뇨제)을 드시는 동안 바나나·염대체소금(칼륨염)은 과하게 드시지 마세요
- 혈중 칼륨이 높아질 수 있어 처방된 혈액검사 일정을 지키고, 근력 저하·심장 두근거림이 있으면 즉시 알려주세요.
⑆img_200409929

# 6. 통증이 있을 때는 우선 타이레놀 계열을 고려하세요(단기간). 소염진통제는 최소 용량·짧게만
- 심장약과 함께 소염진통제(NSAID)를 장기간 쓰면 위장 출혈 위험이 커질 수 있어요. 속쓰림·검은 변이 보이면 연락해 주세요.
⑆img_202002185

# 7. 리보트릴정(진정제)을 드신 날은 밤길 보행 시 조명을 켜고 천천히 움직이세요. 음주는 삼가세요
- 어지러움·졸림으로 넘어질 수 있습니다. 다른 수면제나 술과 함께 드시면 위험합니다.
⑆img_200610884

**[추가 검토 사항]**

**[추가 — 부광로수바스타틴]**

<badge>🏥 공내과의원 선생님께 약물 복용 현황 안내드립니다</badge>
<blockquote>
선생님 안녕하세요. 환자분의 복약 상담을 도와드리고 있는 약사입니다. 약물 복용 현황을 살펴보는 과정에서 선생님께 참고가 될 만한 사항이 있어 안내드립니다.

환자분은 협심증 증상 치료(니코란딜·트리메타지딘)와 2차 예방(아스피린·로수바스타틴), 이뇨제(스피로노락톤)를 복용 중이며, 신경과에서 떨림 치료 목적으로 β차단제(아로티놀롤)·클로나제팜을 병용하고 있습니다. "손떨림, 숨참, 다리부종"을 호소하고 있습니다.
</blockquote>

# 1. 트리메타지딘 복용 현황 안내드립니다
환자분이 '손떨림'을 지속 호소하고 있습니다. 허가사항상 트리메타지딘은 파킨슨병·파킨슨증상·진전 환자에서 금기로 안내되어 있어, 증상과의 관련성 및 지속 필요성에 대한 선생님의 검토를 부탁드립니다.

# 2. 니코란딜 용법과 관련해 문의드립니다
현재 5 mg 1일 2회로 복용하고 계십니다. 허가사항은 5 mg 1일 3회 투여로 명시되어 있어, 증상 조절 상태와 순응도를 고려한 용법 보정 가능성 검토 부탁드립니다. PDE5 억제제와의 병용 금기도 함께 안내드렸습니다.

# 3. 스피로노락톤 안전 모니터링 공유드립니다
고칼륨혈증 예방을 위해 시작/증량 1주 후, 첫 3개월 매월, 이후 3~6개월 간격의 K/Cr 모니터링 권고가 기재되어 있어 일정 확인을 부탁드립니다.

상기 내용은 약물 검토 과정에서 확인된 사항을 참고 차원에서 전달드리는 것이며, 환자분이 안전하고 효과적으로 약물을 복용하실 수 있도록 선생님의 검토 부탁드립니다. 감사합니다.

**다제약물관리 약사 드림**

---

<badge>🏥 참사랑신경과의원 선생님께 약물 복용 현황 안내드립니다</badge>
<blockquote>
선생님 안녕하세요. 환자분의 복약 상담을 도와드리고 있는 약사입니다.

환자분은 협심증 치료(니코란딜·트리메타지딘)와 항혈소판제·스타틴을 복용 중이며, "숨참·다리부종"을 호소합니다. 신경과에서는 아로티놀롤·클로나제팜·메코발라민을 처방받아 복용 중입니다.
</blockquote>

# 1. 아로티놀롤 복용 현황 안내드립니다
호흡곤란 및 말초부종 호소로 울혈성 심부전 가능성이 배제되지 않아, 허가상 금기 사항을 참고 차원에서 공유드립니다. 금기 해당 시(선생님 판단) 중단 필요하나, 급중단은 피해야 함을 환자에게 교육하였습니다.

# 2. 클로나제팜 안전 사용 안내드립니다
고령에서 졸림·낙상 위험 증가 및 장기화 회피 권고가 있어 단기 최소 용량 사용 원칙을 환자분께 교육하였습니다.

상기 내용은 약물 검토 과정에서 확인된 사항을 참고 차원에서 전달드리는 것이며, 환자분이 안전하고 효과적으로 약물을 복용하실 수 있도록 선생님의 검토 부탁드립니다. 감사합니다.

**다제약물관리 약사 드림**

**[추가검토내용]**

---

<badge>🏥 튼튼정형외과의원 선생님께 약물 복용 현황 안내드립니다</badge>
<blockquote>
선생님 안녕하세요. 환자분의 복약 상담을 도와드리고 있는 약사입니다.

환자분은 협심증(니코란딜·트리메타지딘), 항혈소판제(아스피린), 이뇨제(스피로노락톤)를 복용 중이며, 과거 7일간 셀콕시브를 복용하였습니다.
</blockquote>

# 1. 셀콕시브 복용 관련 참고 사항 안내드립니다
허가사항상 확립된 허혈성 심장질환·울혈성 심부전 환자에서 금기로 명시되어 있으며, 저용량 아스피린과 병용 시 위장관 이상반응 위험이 증가할 수 있어 향후 진통제 선택 시 참고 부탁드립니다.

상기 내용은 약물 검토 과정에서 확인된 사항을 참고 차원에서 전달드리는 것이며, 환자분이 안전하고 효과적으로 약물을 복용하실 수 있도록 선생님의 검토 부탁드립니다. 감사합니다.

**다제약물관리 약사 드림**

---

<badge>🏥 해맑은내과의원 선생님께 약물 복용 현황 안내드립니다</badge>
<blockquote>
선생님 안녕하세요. 환자분의 복약 상담을 도와드리고 있는 약사입니다.

환자분은 25.12.30 칸데사르탄 4 mg 30일 처방 이력이 있으며, 26.01.12부터 스피로노락톤을 병용 복용하였습니다.
</blockquote>

# 1. ARB+스피로노락톤 병용 이력 안내드립니다
ARB와 칼륨보존성 이뇨제 병용 시 고칼륨혈증 위험이 있어 전해질 모니터링 필요성이 강조됩니다. 환자분께 칼륨 보충제·염대체소금 회피를 교육하였습니다.

상기 내용은 약물 검토 과정에서 확인된 사항을 참고 차원에서 전달드리는 것이며, 환자분이 안전하고 효과적으로 약물을 복용하실 수 있도록 선생님의 검토 부탁드립니다. 감사합니다.

**다제약물관리 약사 드림**

---

<badge>🏥 정이비인후과의원 선생님께 약물 복용 현황 안내드립니다</badge>
<blockquote>
선생님 안녕하세요. 환자분의 복약 상담을 도와드리고 있는 약사입니다.

환자분은 협심증 치료 및 항혈소판제 복용 중이며, 25.12.09 코싹엘(레보세티리진/슈도에페드린) 7일 처방 이력이 있습니다.
</blockquote>

# 1. 슈도에페드린 사용 관련 참고 사항 안내드립니다
슈도에페드린은 심각한 고혈압 또는 심각한 관상동맥질환 환자에서 금기로 명시되어 있어, 환자분의 심혈관 약물 복용 이력을 고려할 때 향후 충혈완화 치료 시 대체 성분 고려에 대한 선생님의 판단을 부탁드립니다.

상기 내용은 약물 검토 과정에서 확인된 사항을 참고 차원에서 전달드리는 것이며, 환자분이 안전하고 효과적으로 약물을 복용하실 수 있도록 선생님의 검토 부탁드립니다. 감사합니다.

**다제약물관리 약사 드림**`,
    reviewers: [
      {
        label: "A",
        name: "A 약사님",
        affiliation: "",
        comments: [
          { id: 1, location: "p.3 복약지도문", text: "현재 하루 2번으로 처방되어 있으나~", comment: "용법에서 약간 작게 사용하는 경우에 대한 언급은 불필요. Rebamipide 등도 유사. 굳이 환자에게 말할 필요 없다고 판단" },
          { id: 2, location: "p.6 공내과 자문", text: "니코란딜 용법과 관련해 문의드립니다", comment: "이 부분은 애매한데...." },
          { id: 3, location: "p.7 참사랑신경과 자문", text: "급중단은", comment: "용어 확인" },
          { id: 4, location: "p.7 참사랑신경과 자문", text: "허가상 금기 사항을 참고 차원에서", comment: '문장 구성이 조금 애매. → "아로티놀롤이 허가상 심부전 환자에서 금기임을 공유합니다"로 수정 제안' },
          { id: 5, location: "p.7 참사랑신경과 자문", text: "고령에서 졸림·낙상 위험 증가~교육하였습니다", comment: "적응증 평가 전에 단기 최소 사용 원칙 교육이 쉽지 않고, 실제 교육 내용에 없음. → 의사에게 적응증 확인과 지속 필요성 여부 확인 권고, 낙상 위험 알림 등으로 변경 제안" },
          { id: 6, location: "p.10 정이비인후과 자문", text: "충혈완화 치료", comment: '"비충혈제거제"로 용어 변경. 사용 필요 시 단기간 사용으로 언급하는 것이 어떨지' },
        ],
      },
      {
        label: "B",
        name: "B 약사님",
        affiliation: "",
        comments: [
          { id: 1, location: "p5", text: "발기부전약과는 함께 드시면 안 됩니다", comment: "84세 여성이므로 굳이 먼저 알릴 필요는 없다고 생각됨. 안내하더라도 혈관확장효과가 강화되어 어지럼증 느낄 수 있다 정도로. 환자 눈높이에 맞게 풀어서 설명" },
          { id: 2, location: "p5", text: "이 약은 떨림(파킨슨 증상 포함)이 있는 분에게는 맞지 않을 수 있습니다.", comment: "약 때문에 파킨슨병에 걸릴 수도 있겠구나..라고 오해할 수 있을 것 같음. 손떨림이 지속된다면 공내과 진료 시 꼭 말씀하셔서 약 처방을 점검받도록 안내" },
          { id: 3, location: "p6", text: "갑자기 끊지 말고,", comment: "★ 환자가 임의로 상의없이 특정 약만 중단할 가능성은 거의 없기 때문에, 숨이 차거나 다리부종이 지속적일 때 처방의와 반드시 상의하라고 안내하고 이 약의 감량이 서서히 이루어져야 함은 처방의를 통해서 전달되는 게 맞다고 생각이 됨" },
          { id: 4, location: "p6", text: "염대체소금(칼륨염)은", comment: "바나나, 시금치 등 칼륨수치를 높이는 식품을 사진으로 제공하면 좋을 것 같고 생야채 손질 시 물에 담가두거나 데쳐서 사용하는 조리법을 같이 안내. 염대체소금이라는 표현이 조금 생소하게 느껴질 수 있을 것 같음" },
          { id: 5, location: "p6", text: "추가 검토 사항", comment: "위 대상자가 해맑은내과(ARB) 처방을 받고 2주 후에 공내과(메인병원)를 가셨는데 사유가 있었는지 확인하고 정확한 모니터링을 위해 가급적 한곳에서만 처방을 받도록 안내 필요" },
          { id: 6, location: "p6", text: "심장약과 함께 소염진통제", comment: "심장약이라고 하면 범주가 넓고 너무 두루뭉실한 표현이라, 항혈전제라고 정확히 알리는 것이 좋겠음. 정형외과 진료시에 항혈전제를 복용중임을 꼭 알리시게 안내하고, 소염진통제는 아프지 않을 때는 드시지 않도록 교육" },
          { id: 7, location: "p7", text: "밤길 보행 시", comment: "밤길 보행 → 야간에 깨서 화장실 가실 때 넘어지지 않도록 수면등 사용 권고. 운전 주의 강조하고, 현실적으로 봤을 때 음주 가능성은 별로 없지만 함께 언급" },
          { id: 8, location: "p8", text: "허가사항은 5 mg 1일 3회 투여로 명시되어 있어,", comment: "허가사항 문구에 연령, 증상에 따라 적절히 증감한다고 되어 있어서 굳이 말씀을 드려야 할지 고민됨" },
          { id: 9, location: "p9", text: "호흡곤란 및 말초부종 호소로 울혈성 심부전 가능성이 배제되지 않아", comment: "다음 외래진료 시 주치의와 반드시 상담이 필요하며, 약을 갑자기 중단하시면 안됨을 환자에게 교육하였습니다" },
        ],
      },
      {
        label: "C",
        name: "C 약사님",
        affiliation: "",
        comments: [
          { id: 2, location: "p5", text: "발기부전약과는 함께 드시면 안 됩니다", comment: "여성이라면 필요없는 정보" },
          { id: 6, location: "p6", text: "염대체소금(칼륨염)은", comment: "저나트륨소금이라는 표현이 쉬울 것 같습니다" },
          { id: 3, location: "p6", text: "소염진통제는 최소 용량", comment: "협심증 자체에 COX2 저해제가 적합하지 않으므로 처방 변경을 고려하는 것이 좋겠습니다" },
          { id: 4, location: "p7", text: "추가 검토 사항", comment: "추가의견: 약물검토 내용이 아닐 수 있으나 내과를 두 군데가 아닌 한 군데로 지정해서 다닐 것을 권고하고 싶습니다" },
          { id: 5, location: "p9", text: "추가검토내용", comment: "구체적으로 무슨 검토를 부탁드리는지 명시 필요. 구체적이지 않다면 빼도 된다고 생각합니다" },
        ],
      },
      { label: "D", name: "D 약사님", affiliation: "", comments: [
          { id: 1, location: "정이비인후과 자문", text: "향후 충혈완화 치료 시 대체 성분 고려에 대한 선생님의 판단을 부탁드립니다", comment: "처방시 고려할 약에 대한 대안도 제시해주는 것이 좋겠습니다" },
          { id: 2, location: "해맑은내과 자문", text: "ARB와 칼륨보존성 이뇨제 병용 시 고칼륨혈증 위험이 있어 전해질 모니터링 필요성이 강조됩니다", comment: "환자에게 아직 일어난 부작용이 없는 상태라 제안시 오해 소지가 있어 근거제시를 함께하는 것이 좋겠습니다" },
      ] },
      { label: "E", name: "E 약사님", affiliation: "", comments: [
          { id: 1, location: "p5 복약지도문", text: "아스트릭스캡슐(아스피린)을 드시는 동안", comment: "장용정: 우유X" },
          { id: 2, location: "p5 복약지도문", text: "발기부전약과는 함께 드시면 안 됩니다", comment: "남성에게만 표기되도록" },
          { id: 26, location: "p5 복약지도문", text: "하루 3번이 필요할 수 있어요", comment: "대부분 1일 2회가 많다" },
          { id: 3, location: "p6 복약지도문", text: "염대체소금(칼륨염)은", comment: "녹즙 금지. 야채는 물에 담근 다음 드시거나 데치기. 염대체소금 → '건강에 좋다는 소금' 이라고 수식어 추가" },
          { id: 4, location: "p6 복약지도문", text: "·짧게만", comment: '"복용하세요" 누락' },
          { id: 27, location: "p6 복약지도문", text: "타이레놀 계열을 고려하세요", comment: '"타이레놀" → "아세트아미노펜(타이레놀)"로 변경' },
          { id: 5, location: "p7 복약지도문", text: "밤길 보행 시", comment: '"자다가 깨서 움직일 때 특히 조심하세요" ' },
          { id: 6, location: "p7 복약지도문", text: "추가 — 부광로수바스타틴", comment: "부광로수바스타틴 — 혹시 심한 근육통이나 소변양이 줄고 콜라색이면 일단 약 복용을 중단하시고 병원에 가셔서 소변과 피검사를 받아 보시면 안전합니다. 작년에 2~3 콜라색 소변 환자를 보고 바로 병원에서 검사하고 입원한 적이 있어서.. 저에겐 고지혈증의 부작용 체크가 필수로 되어있어요" },
          { id: 7, location: "p8 공내과 자문", text: "니코란딜 용법과 관련해 문의드립니다", comment: "항목 전체 빼기(−). 사실 시그마트는 1일 3회보다는 1일 2회 용법이 많은 것 같다. 1정×2회 또는 0.5정×2회가 많다. 가장 보편적인 용법은 1일 2회" },
          { id: 8, location: "p10 튼튼정형외과 자문", text: "허가사항상 확립된 허혈성 심장질환·울혈성 심부전 환자에서 금기로 명시", comment: "(+) 아세트아미노펜이나 트라마돌성분 진통제등 심혈관에 부담이 적은 성분의 처방을 고려해 주시면 감사하겠습니다" },
          { id: 9, location: "p12 정이비인후과 자문", text: "대체 성분 고려에 대한", comment: "배뇨장애 가능성 안내 / 비강분무형 추천" },
      ] },
    ],
  },
  {
    patientId: 1390,
    reportId: 3147,
    label: "환자 2",
    content: `<badge>💊 약 복용 시 특히 주의해야 할 점</badge>
# 1. 아스피린은 한 가지 제품만 드세요(겹쳐 드시면 출혈 위험이 커집니다)
- 현재 처방 아스피린이 있어, 시중에서 산 아스피린까지 함께 드시면 멍·코피·검은 변 같은 출혈 위험이 커질 수 있습니다. 겹쳐 드시지 않도록 꼭 확인해 주세요.
⑆img_201206820 ⑆img_201402959

# 2. 콜레스테롤약(로수바스타틴)과 제산제(마그네슘)는 시간 간격을 두고 드세요
- 두 약을 같이 드시면 콜레스테롤약의 약효가 약해질 수 있습니다. 콜레스테롤약을 먼저 드시고 최소 2시간 뒤에 제산제를 드시는 것이 좋습니다.
⑆img_201001003 ⑆img_199802384

# 3. 배뇨·방광약 복용 중 어지러움·입마름·변비가 심하면 알려주세요
- 솔리페나신은 입마름·변비를, 탐스로신은 갑자기 일어설 때 어지러움을 잘 일으킬 수 있습니다. 밤에 일어날 때는 먼저 앉았다가 천천히 일어나시고, 증상이 지속되면 다음 진료 때 말씀해 주세요.
⑆img_201404483 ⑆img_201603377 ⑆img_202101478 미라베서방정

# 4. 미라베그론(과민성방광 약) 복용 중에는 가정혈압을 주 2~3회 확인해 주세요
- 이 약은 맥박과 혈압이 오를 수 있습니다. 두통이나 두근거림이 생기거나 혈압이 높게 계속 나오면 다음 진료 때 꼭 말씀해 주세요.
⑆img_202101478

# 5. 변비약은 아침 식전 규칙적으로, 설사하면 줄이거나 잠시 쉬어 주세요
- 락툴로오즈 시럽은 아침 식전에 드시는 것이 좋고, 묽은 변이 나올 때는 양을 줄이거나 쉬어야 합니다. 물을 충분히 마시고 가벼운 걷기도 도움이 됩니다.
⑆img_201211097

# 6. 메트포르민(당뇨약)은 저녁 식사와 함께, 음주는 피하시는 것이 좋습니다
- 저녁 식사와 함께 드시면 속불편이 줄고, 술과 함께 드시면 드물게 위험한 산증이 생길 수 있어 음주는 피하시는 것이 좋습니다.
⑆img_201002151

# 7. 홍삼 제품과 아스피린을 함께 드실 때는 멍·출혈에 유의해 주세요
- 홍삼은 혈소판 응집을 억제해 혈액순환에 도움을 줄 수 있지만, 아스피린과 함께 드실 때는 멍이나 출혈이 늘어날 수 있어 주의가 필요합니다. 이상이 있으면 전문가와 상의해 주세요.
⑆img_201206820

**[추가 검토 항목]**

<badge>🏥 모두병원 선생님께 약물 복용 현황 안내드립니다</badge>
<blockquote>
선생님 안녕하세요. 환자분의 복약 상담을 도와드리고 있는 약사입니다. 약물 복용 현황을 살펴보는 과정에서 선생님께 참고가 될 만한 사항이 있어 안내드립니다.

환자분은 귀 의료기관(고혈압/당뇨/이상지질혈증/변비·역류)과 더블루비뇨기과의원(OAB/BPH)에서 치료 중이며, 낙상 기왕력이 있고 최근 혈압 160/80mmHg, HbA1c 8%로 보고되었습니다. 변비와 항콜린성 부작용(구갈·어지러움·수면 이상)을 호소합니다.
</blockquote>

# 1. 고혈압 미조절과 발사르탄 용량 관련 복용 현황 안내드립니다
- 현재 발사르탄 40mg 1일 1회 복용 중이며, 혈압이 160/80mmHg입니다. 일반 성인 권장 시작용량은 80mg/일로 기재되어 있어, 증량(80→160mg/일) 또는 단계적 병용 추가 검토가 필요한 상황으로 보입니다. 가정혈압 기록도 함께 확인 부탁드립니다.

# 2. 당뇨병 조절 강화 필요성에 대해 공유드립니다
- HbA1c 8%로 확인되어 메트포르민 증량(1,500~2,000mg/일, 내약성/신기능 조건) 또는 SGLT2/DPP-4 추가를 고려할 시점으로 판단됩니다. 저녁식사와 함께 복용 및 음주 회피 교육을 시행하였습니다.

# 3. 프루칼로프라이드 및 완하제 병용 관련
- 프루칼로프라이드 4주 투여 후 반응이 없으면 재평가, 장기 지속 시 정기 재평가 권고되어 있어 추후 내원 시 확인 부탁드립니다. 락툴로오즈·수산화마그네슘과의 다중 병용은 항콜린제 조정 후 단계 감량 계획이 유익할 수 있습니다.

# 4. 로수바스타틴–제산제 동시 복용에 대해 안내드립니다
- 수산화마그네슘 제산제와 동시 복용 시 로수바스타틴 혈중농도가 약 50% 감소하는 것으로 기재되어 환자분께 복용 간격(2시간 이상) 안내하였습니다.

# 5. 아스피린 중복 및 홍삼 병용 관련
- 자가로 글로아스피린(OTC)을 간헐 복용 중으로 확인되어 중복 위험에 대해 교육하였습니다. 또한 홍삼(혈소판 응집 억제 기능성)과의 병용 시 출혈 위험 증가 가능성에 대해 안내드렸습니다. 필요 시 1제만 유지하도록 정리 요청드립니다.

상기 내용은 약물 검토 과정에서 확인된 사항을 참고 차원에서 전달드리는 것이며, 환자분이 안전하고 효과적으로 약물을 복용하실 수 있도록 선생님의 검토 부탁드립니다. 감사합니다.

**다제약물관리 약사 드림**

**[추가 검토 항목 — 모두병원]**

---

<badge>🏥 더블루비뇨기과의원 선생님께 약물 복용 현황 안내드립니다</badge>
<blockquote>
선생님 안녕하세요. 환자분의 복약 상담을 도와드리고 있는 약사입니다. 약물 복용 현황을 살펴보는 과정에서 선생님께 참고가 될 만한 사항이 있어 안내드립니다.

환자분은 OAB/BPH로 탐스로신+두타스테리드+솔리페나신(2.5mg/일)+미라베그론 50mg 병용 중입니다. "배뇨 직후 요의", "구갈·변비·어지러움"과 야간 수면 이상행동(고함/헛소리)을 호소하고, 낙상(3개월 전) 기왕력이 있습니다. 최근 혈압은 160/80mmHg입니다.
</blockquote>

# 1. 항콜린성 부담과 OAB 치료 단순화 가능성에 대해 공유드립니다
- 솔리페나신은 강한 항콜린성 약제로 구갈·변비 및 인지/수면 이상을 유발할 수 있으며(항콜린 점수 3점), 요저류 환자 금기로 기재되어 있습니다. 잔뇨·요저류 위험 평가와 함께, 미라베그론 단독 유지 등 항콜린 부담을 줄이는 방향을 검토해 주실 수 있을지 문의드립니다(현재 솔리페나신 2.5mg은 허가 용량(5mg) 미만).

# 2. 변비 다중 치료(락툴로오즈·수산화마그네슘·프루칼로프라이드)와 연쇄처방 가능성
- 항콜린제 기인 변비 악화 가능성을 고려하여, 원인약 조정 후 완하제 단계 감량이 유익할 것으로 보입니다. 프루칼로프라이드 4주 반응 평가·장기 지속 시 정기 재평가 또한 부탁드립니다.

# 3. 탐스로신과 낙상 위험
- 기립성 저혈압에 따른 어지러움 가능성이 있어, 증상 지속 시 용량·복용시점 조정 등 검토 부탁드립니다.

# 4. 미라베그론과 혈압
- 미라베그론은 맥박·혈압 상승 가능성이 있어(중증·조절 안 되는 고혈압 금기), 현재 SBP 160mmHg 상태에서 가정혈압 모니터링을 시행토록 안내하였고, 필요 시 치료전략 조정 검토 부탁드립니다.

상기 내용은 약물 검토 과정에서 확인된 사항을 참고 차원에서 전달드리는 것이며, 환자분이 안전하고 효과적으로 약물을 복용하실 수 있도록 선생님의 검토 부탁드립니다. 감사합니다.

**다제약물관리 약사 드림**`,
    reviewers: [
      {
        label: "A",
        name: "A 약사님",
        affiliation: "",
        comments: [
          { id: 1, location: "p.3 복약지도문", text: "(겹쳐 드시면", comment: "어구 적절성 검토" },
          { id: 2, location: "p.3 복약지도문", text: "두 약을 같이 드시면 콜레스테롤약의 약효가 약해질 수 있습니다.", comment: "★ 유의한 상호작용인지 확인 필요" },
          { id: 3, location: "p.5 복약지도문", text: "홍삼 제품과 아스피린을 함께~", comment: "★ 근거 확인 필요" },
          { id: 4, location: "p.7 모두병원 자문", text: "고혈압 미조절과", comment: "어구 자연스러운가?" },
          { id: 5, location: "p.8 더블루비뇨기과 자문", text: "기립성 저혈압에", comment: "tamsulosin은 비교적 기립성 저혈압 위험성이 낮은 약인데 이렇게 강조할 필요가 있을지" },
        ],
      },
      {
        label: "B",
        name: "B 약사님",
        affiliation: "",
        comments: [
          { id: 11, location: "p15", text: "제산제(마그네슘)는", comment: "제산제 및 변비약이며, 현재 환자분의 상황에서는 변비약으로 인식하고 계실 가능성이 큽니다. 따라서 변비약의 경우, 아침 식전 공복(듀락칸이지시럽, 루칼로정 1MG), 저녁 자기전(신일엠정)으로 복용시간을 구분해서 안내하는 게 환자 입장에서는 이해하기 쉬울 것 같습니다. 라미나지액은 속쓰림 심할 때 공복 복용하고, 다른 약과 1시간 이상 간격을 두라고 함께 안내" },
          { id: 12, location: "p16", text: "미라베서방정", comment: "항콜린부작용 설명하면서 솔리신정과 미라베그론이 함께 있으면 원인약물 확인에 혼동을 줄 수 있을 것 같음" },
          { id: 13, location: "p17", text: "술과 함께 드시면 드물게 위험한 산증", comment: "조영제를 사용하는 검사(CT/MRI/혈관조영술 등) 전 24~48시간 전부터 복용 중단함도 같이 안내" },
          { id: 14, location: "p17", text: "아스피린과 함께 드실 때는 멍이나 출혈이 늘어날 수 있어 주의가 필요합니다", comment: "현재 복용 중이신 건기식 홍삼 외에도 은행나무 추출물, 오메가3 등 출혈경향에 영향을 주는 약품, 식품 정보 제공하여 리마인드" },
          { id: 15, location: "p17", text: "변비약은 아침 식전 규칙적으로,", comment: "2번 항과 묶어서 한꺼번에 설명하는 게 좋겠습니다" },
        ],
      },
      {
        label: "C",
        name: "C 약사님",
        affiliation: "",
        comments: [
          { id: 6, location: "p15", text: "제산제(마그네슘)는", comment: "제산제가 아닌 변비로 인해 처방했을 가능성이 큽니다" },
          { id: 7, location: "p17", text: "저녁 식사와 함께 드시면", comment: "복약이행도를 고려하여 다른 약과 아침에 함께 복용하는 경우가 많고 의사 처방에 용법을 명시하는 경우가 많아 저녁식사라는 문구는 삭제 필요" },
          { id: 8, location: "p17", text: "술과 함께 드시면 드물게 위험한 산증", comment: "음주 관련 내용과 함께 CT, MRI 검사 시 복용여부를 알리라는 내용도 들어가면 좋겠습니다" },
        ],
      },
      { label: "D", name: "D 약사님", affiliation: "", comments: [
          { id: 3, location: "모두병원 자문", text: "HbA1c 8%로 확인되어 메트포르민 증량(1,500~2,000mg/일, 내약성/신기능 조건) 또는 SGLT2/DPP-4 추가를 고려할 시점으로 판단됩니다.", comment: "당조절이 안되고 있는 상태를 좀더 신뢰성있게 제공하는 틀이 필요할 것 같고, 관련 근거제시와 함께 의견을 제시하면 좋겠습니다" },
      ] },
      { label: "E", name: "E 약사님", affiliation: "", comments: [
          { id: 10, location: "p15 복약지도문", text: "겹쳐 드시면", comment: "빼기(−)" },
          { id: 11, location: "p16 복약지도문", text: "콜레스테롤약(로수바스타틴)과", comment: "상품명 기재 필요" },
          { id: 12, location: "p17 복약지도문", text: "저녁 식사와 함께", comment: "많은 경우가 아침 복용을 권함" },
          { id: 13, location: "p18 복약지도문", text: "추가 검토 항목", comment: '당뇨약 고지혈증 약 복용시 용법을 저녁으로 안내하는 경우가 많이 있는데, 실제로 저희는 특별한 경우가 아니면 아침으로 안내를 하고 있습니다. 저녁약을 놓치고 복용하는 경우가 많아서 일단 안정적인 투약을 위해 아침으로 권하고, 1일 2회~3회보다는 1일 1회가 좋은것 같고, 혹여 아침 저녁으로 수시로 변경은 하지 않도록 합니다' },
          { id: 14, location: "p19 모두병원 자문", text: "저녁식사와", comment: '"저녁식사" 밑줄' },
          { id: 15, location: "p20 모두병원 자문", text: "추가 검토 항목 — 모두병원", comment: "라미나지 변비 언급이 있었으면 좋겠습니다" },
          { id: 28, location: "p17 복약지도문", text: "홍삼 제품과 아스피린을 함께 드실 때는 멍·출혈에 유의해 주세요", comment: "항목 전체 빼기(−)" },
      ] },
    ],
  },
  {
    patientId: 1391,
    reportId: 3148,
    label: "환자 3",
    content: `<badge>💊 약 복용 시 특히 주의해야 할 점</badge>
# 1. 플라빅스(혈전 예방약)를 드시는 동안, 위장약(에소젠40)·진통제(NSAID)와의 병용은 조심하시는 것이 좋습니다
- 에소젠40(에스오메프라졸)과 함께 드시면 플라빅스의 효과가 약해질 수 있습니다. 통증약 중 NSAID(이부프로펜 등)는 멍, 검은변 같은 출혈 위험을 높일 수 있어요. 필요 시 다른 위장약·진통제로 조정이 필요하니 다음 진료 때 꼭 말씀해 주세요.
⑆img_200700907 ⑆img_201507502

# 2. 슈다페드(코막힘약)는 심장·혈관질환 및 당뇨가 있으신 분께는 맞지 않을 수 있습니다
- 심장병·말초혈관질환, 당뇨, 베타차단제(네비스톨) 드시는 분은 슈다페드가 금기입니다. 코세척(식염수)이나 비강 분무제(7일 이내) 같은 방법을 우선 사용해 주세요.
⑆img_197900575

# 3. 수면제(스틸녹스)와 신경안정제(자낙스·클로나제팜)는 최소량만, 취침 직전에만 드시는 것이 좋습니다
- 고령자에서는 스틸녹스는 5mg 이하가 권장됩니다. 복용 후 최소 7~8시간은 주무시고, 다음날 어지러움·졸림이 있으면 낙상 주의가 필요합니다. 다른 진정제와 같은 날 함께 드시지 않도록 해 주세요.
⑆img_200700634 ⑆img_200410869 ⑆img_201400403

# 4. 니코란딜·몰시도민(협심증약)을 드시는 동안 발기부전 치료제와는 절대 함께 드시면 안 됩니다
- 함께 복용하면 심한 저혈압이 생길 수 있습니다. 다른 병원 진료 시에도 현재 복용 중임을 꼭 알려주세요.
⑆img_198500125 ⑆img_199802244

# 5. 네비스톨(심장약)과 당뇨약(다이아민XR)을 함께 드실 때 저혈당 신호를 잘 못 느낄 수 있습니다
- 식사를 거르지 말고, 어지럽거나 식은땀이 날 때는 혈당을 확인해 주세요. 알코올은 메트포르민과 함께 유산산증 위험을 높일 수 있어 삼가시는 게 좋습니다.
⑆img_201707657 ⑆img_200610962

# 6. 알레르기 약은 한 가지만 드셔도 충분합니다
- 페니라민(졸림 유발 1세대)과 유니베포타(2세대)를 같이 드시면 입마름·변비·어지러움이 생길 수 있어요. 가능한 2세대 약 위주로 조정해 주세요.
⑆img_196000011 ⑆img_201706786

# 7. 모사프로진(소화제)은 보통 하루 3번 복용이 표준입니다
- 현재 하루 1번 복용으로는 효과가 부족할 수 있습니다. 식사와 증상 연관을 기록해 오시면, 다음 진료 때 용법 조정에 도움이 됩니다.
⑆img_201603089

**[추가 검토 사항]**

<badge>🏥 맑은이비인후과의원 선생님께 약물 복용 현황 안내드립니다</badge>
<blockquote>
선생님 안녕하세요. 환자분의 복약 상담을 도와드리고 있는 약사입니다. 약물 복용 현황을 살펴보는 과정에서 선생님께 참고가 될 만한 사항이 있어 안내드립니다.

환자분은 미래종합병원에서 협심증/말초혈관질환(클로피도그렐, 니코란딜, 몰시도민, 네비보롤 등), 당뇨병(메트포르민), 지질이상증 치료를 지속 중입니다. 수면장애가 있어 진정·수면제 병력도 확인됩니다.
</blockquote>

# 1. 슈도에페드린 복용 현황 안내드립니다
- 환자분은 말초혈관질환/허혈성 심질환 및 당뇨를 동반하고 베타차단제(네비보롤) 복용 중입니다. 슈도에페드린은 심혈관질환/당뇨 환자 및 베타차단제 병용 시 금기여서(라벨 상) 대체가 필요해 보입니다(비강 분무형 단기 사용 또는 식염수 세척 등).

# 2. 에스오메프라졸과 클로피도그렐의 병용 회피가 필요합니다
- 클로피도그렐과 에스오메프라졸 병용 시 활성 대사체 노출 및 항혈소판 반응 저하가 보고되어(라벨 상) 가능하면 병용 회피가 필요합니다. 위장약 필요 시 영향이 적은 대안을 고려해 주실 수 있을지요.

# 3. 항히스타민 병용 필요성 확인 부탁드립니다
- 1세대(클로르페니라민)와 2세대(베포타스틴)의 병용은 고령 환자에서 항콜린·진정 부작용을 증가시킬 수 있어, 가능하면 2세대 위주 단일화가 바람직해 보입니다.

상기 내용은 약물 검토 과정에서 확인된 사항을 참고 차원에서 전달드리는 것이며, 환자분이 안전하고 효과적으로 약물을 복용하실 수 있도록 선생님의 검토 부탁드립니다. 감사합니다.

**다제약물관리 약사 드림**

---

<badge>🏥 아름다운피부과의원 선생님께 약물 복용 현황 안내드립니다</badge>
<blockquote>
선생님 안녕하세요. 환자분의 복약 상담을 도와드리고 있는 약사입니다. 항혈소판제(클로피도그렐)를 포함한 심혈관 약물을 지속 복용 중인 환자분입니다.
</blockquote>

# 1. 덱시부프로펜과 항혈소판제 병용 관련 출혈 위험 안내드립니다
- 클로피도그렐과 NSAID 병용 시 위장관 출혈 위험이 증가하는 것으로 라벨에 기재되어 있습니다. 통증 조절이 필요할 경우 아세트아미노펜 등 대체를 우선 고려해 주시면 감사하겠습니다.

# 2. 레바미피드 용법 관련
- 표준 용법은 100mg 1일 3회(위궤양 시 아침·저녁·취침 전)입니다. 단기 증상에 맞춰 필요시 복용으로도 충분할 수 있어 용법 확인 부탁드립니다.

상기 내용은 약물 검토 과정에서 확인된 사항을 참고 차원에서 전달드리는 것이며, 환자분이 안전하고 효과적으로 약물을 복용하실 수 있도록 선생님의 검토 부탁드립니다. 감사합니다.

**다제약물관리 약사 드림**

---

<badge>🏥 미래종합병원 선생님께 약물 복용 현황 안내드립니다</badge>
<blockquote>
선생님 안녕하세요. 환자분의 복약 상담을 도와드리고 있는 약사입니다. 협심증/말초혈관질환·당뇨·지질이상증으로 장기 치료 중이며, 과거 진정·수면제 다제 병력이 있습니다.
</blockquote>

# 1. 진정·수면제 다제 및 고령자 용량 관련 현황 안내드립니다
- 클로나제팜·알프라졸람·졸피뎀의 병용 이력이 있고, 졸피뎀 10mg 처방 이력이 있습니다. 고령자는 5mg 권장 및 최소 기간 사용이 필요하여, 감량·단일화 검토를 부탁드립니다(금단 예방을 위한 서서히 감량 원칙).

# 2. 모사프리드 용법 재평가 요청드립니다
- 표준 용법은 1일 3회(총 15mg)로, 현재 1일 1회는 효과가 제한될 수 있습니다. 증상-식사 연관 평가 후 용법 조정 또는 대체 검토 부탁드립니다.

# 3. 질산염계 복용 중 PDE5 억제제 병용 금지 교육 공유드립니다
- 니코란딜·몰시도민 복용 중 PDE5 억제제 병용 금기(중증 저혈압 위험)임을 환자 교육하였습니다.

상기 내용은 약물 검토 과정에서 확인된 사항을 참고 차원에서 전달드리는 것이며, 환자분이 안전하고 효과적으로 약물을 복용하실 수 있도록 선생님의 검토 부탁드립니다. 감사합니다.

**다제약물관리 약사 드림**

**[추가의견]**`,
    reviewers: [
      {
        label: "A",
        name: "A 약사님",
        affiliation: "",
        comments: [
          { id: 1, location: "p.8 아름다운피부과 자문", text: "아름다운피부과의원 선생님께", comment: "단기간만 처방되었는데 모두 이야기할 필요가 있을지?" },
          { id: 2, location: "p.6 복약지도문", text: "추가 검토 사항", comment: "자큐보정(자스타프라잔)은 언급 없는가?" },
          { id: 3, location: "p.3 복약지도문", text: "심장병·말초혈관질환~슈다페드가 금기입니다", comment: "허가사항에 나오긴 하지만, 현재 급성 문제 없는 사람에서 일반적으로 금기라고 엄격하게 이야기하고 있지 않아서 고민" },
          { id: 4, location: "p.4 복약지도문", text: "복용 후 최소 7~8시간은 주무시고", comment: "무슨 의미인지...?" },
          { id: 5, location: "p.4 복약지도문", text: "다른 진정제와 같은 날 함께 드시지 않도록~", comment: "직접 이야기해도 될지... 자낙스·클로나를 다른 목적으로, 수면제로 복용하는 경우에 말할 근거가 있는지 고민" },
          { id: 6, location: "p.5 복약지도문", text: "알레르기 약은 한 가지만 드셔도 충분합니다", comment: "너무 단정적?" },
          { id: 7, location: "p.6 복약지도문", text: "모사프로진 하루 1번 복용으로는 효과가 부족", comment: "실제 별 이유없이 복용하고 있다면 부족함을 이야기해야 하는가?" },
          { id: 8, location: "p.7 맑은이비인후과 자문", text: "(라벨 상)", comment: '표현? → "허가 상"으로 변경 제안' },
          { id: 9, location: "p.7 맑은이비인후과 자문", text: "적은 대안을 고려해 주실 수 있을지요", comment: "★ 대안을 제시하면?" },
          { id: 10, location: "p.8 아름다운피부과 자문", text: "라벨에 기재되어 있습니다", comment: "(강조 — 용어 통일) → \"허가사항\"으로 변경" },
          { id: 11, location: "p.8 아름다운피부과 자문", text: "표준 용법은 100mg 1일 3회(위궤양 시 아침·저녁·취침 전)입니다. 단기 증상에 맞춰 필요시 복용으로도 충분할 수 있어 용법 확인 부탁드립니다.", comment: "치료 목적이라면 제대로 용량 사용하도록. 필요시 복용의 근거는?" },
          { id: 12, location: "p.9 미래종합병원 자문", text: "병용 이력이 있고, 졸피뎀 10mg 처방 이력이 있습니다. 고령자는 5mg 권장 및 최소 기간 사용이 필요하여, 감량·단일화 검토를 부탁드립니다", comment: "(강조)" },
        ],
      },
      {
        label: "B",
        name: "B 약사님",
        affiliation: "",
        comments: [
          { id: 16, location: "p23", text: "플라빅스(혈전 예방약)를 드시는 동안, 위장약(에소젠40)·진통제(NSAID)와의 병용은 조심하시는 것이 좋습니다", comment: "★ 상기 환자는 ENT에서 단기로 에소젠40을 5일간 처방받음. 그런데 메인병원에서 위장장해 예방목적으로 자큐보정이 포함되어있음. 환자를 통해 위장약을 먹고 있음을 진료시마다 알리게 하는 것이 좋겠고, 환자 복약지도문에 굳이 쓸 필요는 없을 것 같음" },
          { id: 17, location: "p24", text: "수면제(스틸녹스)와 신경안정제(자낙스·클로나제팜)는 최소량만, 취침 직전에만 드시는 것이 좋습니다", comment: "메모 내용을 보시면 105일 처방이 루틴이며 스틸녹스와 자낙스가 PRN으로 예상. ①글리아틴 BID를 아침에만 복용하거나 은행엽추출물 등으로 변경 제안 ②스틸녹스정 0.5정 사용하고 안되면 1정 사용하시게 지도 ③자낙스는 스틸녹스로 안될 때 추가하는 것으로 제안" },
          { id: 18, location: "p24", text: "고령자에서는 스틸녹스는 5mg 이하가 권장됩니다", comment: "위와 같이 구체적으로 지도하지 않으면 환자들의 순응도가 떨어지게 되는데, 정신과 약물은 의료진의 치료 계획을 정확하게 알지 못할 시 문제가 될 수도 있기 때문에 매우 조심스럽고, 의견서를 드릴 때도 정리를 잘 해야 할 것 같습니다" },
          { id: 19, location: "p25", text: "알레르기 약은 한 가지만 드셔도 충분합니다", comment: "피부과, 이비인후과에서 증상이 심한 경우 꽤 빈번하게 항히스타민제 중복 처방이 나오기 때문에 위와 같은 워딩이 주치의와 라포 형성을 방해할 수 있다고 생각됩니다. 환자에게는 졸림이 심하게 유발되는 1세대 약에 대해서 부작용을 강조하는 교육 정도로 코멘트하는 게 좋을 것 같습니다" },
          { id: 20, location: "p26", text: "모사프로진(소화제)은 보통 하루 3번 복용이 표준입니다", comment: "임상에서 1일 1회 복용하는 다른 약들과 묶어져서 자주 이렇게 나오기 때문에 굳이 언급하지 않아도 되지 않을까 생각이 듭니다" },
          { id: 21, location: "p27", text: "에스오메프라졸과 클로피도그렐의 병용 회피가 필요합니다", comment: "★ 2번 3번 항에 대해서 저라면 굳이 환자를 통해 의료진께 전달하기보다는, 환자를 제가 직접 교육하는 선에서 조정할 것 같습니다" },
          { id: 25, location: "p27", text: "항히스타민 병용 필요성 확인 부탁드립니다", comment: "(↑ 위 2번과 동일) 환자를 제가 직접 교육하는 선에서 조정할 것 같습니다" },
          { id: 22, location: "p28", text: "아름다운피부과의원 선생님께", comment: "피부과에는 서신이 불필요해 보입니다" },
          { id: 23, location: "p29", text: "모사프리드 용법 재평가 요청드립니다", comment: "불필요" },
        ],
      },
      {
        label: "C",
        name: "C 약사님",
        affiliation: "",
        comments: [
          { id: 9, location: "p23", text: "에소젠40(에스오메프라졸)과 함께 드시면 플라빅스의 효과가 약해질 수 있습니다.", comment: "★ 에스오메프라졸과의 상호작용은 환자에게 필요한 정보는 아닌 것 같습니다. 진통제는 아세트아미노펜을 권장한다는 정도의 정보만 들어가도 좋겠습니다" },
          { id: 10, location: "p23", text: "슈다페드(코막힘약)는 심장·혈관질환 및 당뇨가 있으신 분께는 맞지 않을 수 있습니다", comment: "이 역시 환자보다는 의사에게 알려야 하는 정보" },
          { id: 11, location: "p25", text: "네비스톨(심장약)과 당뇨약(다이아민XR)을 함께 드실 때 저혈당 신호를 잘 못 느낄 수 있습니다", comment: "메트포르민의 저혈당 빈도가 크지 않아 불필요한 정보라고 생각합니다" },
          { id: 12, location: "p25", text: "알레르기 약은 한 가지만 드셔도 충분합니다", comment: "역시 환자보다 의사에게 알려야 할 정보" },
          { id: 13, location: "p26", text: "추가 검토 사항", comment: "추가의견: 자큐보와 에스오메프라졸은 효능 중복입니다. 비슷한 위장약을 처방받았음을 환자에게 알리고, 복용중인 약물을 의료진에게 알리도록 교육할 필요가 있습니다" },
          { id: 14, location: "p28", text: "레바미피드 용법 관련", comment: "덱시부프로펜 위장장애 예방으로 함께 처방하였으므로 복약이행도를 고려하여 1일2회 처방한 것으로 보임. 불필요한 정보라고 생각됩니다" },
          { id: 15, location: "p29", text: "추가의견", comment: "자스타프라잔, 모사프리드 처방이 지속되고 있고, 다른 병원의 PPI, 레바미피드 등 효능 중복 발생. 위장약들은 불필요하게 복사 처방되는 경우가 많으므로 처방 경위와 현재 위염/식도염 상태를 확인하여 치료되었거나 증상이 완화되었다면 처방 삭제 요청 필요" },
        ],
      },
      { label: "D", name: "D 약사님", affiliation: "", comments: [
          { id: 4, location: "복약지도문", text: "심장병·말초혈관질환, 당뇨, 베타차단제(네비스톨) 드시는 분은 슈다페드가 금기입니다", comment: "환자 제공시 불안을 만들 수 있고 의사와의 신뢰도 떨어질 수 있어, 금기 부분은 의사 전달로 하고 환자에게는 심각한 부작용 설명을 제공하여 복용하지 않도록 주의차 알려줄 것" },
          { id: 5, location: "맑은이비인후과 자문", text: "대체가 필요해 보입니다(비강 분무형 단기 사용 또는 식염수 세척 등)", comment: "대체 가능한 약물 제공 필요" },
      ] },
      { label: "E", name: "E 약사님", affiliation: "", comments: [
          { id: 16, location: "p24 복약지도문", text: "발기부전 치료제와는 절대 함께 드시면 안 됩니다", comment: "남성에게만 표현" },
          { id: 17, location: "p25 복약지도문", text: "네비스톨(심장약)과 당뇨약(다이아민XR)을 함께 드실 때 저혈당 신호를 잘 못 느낄 수 있습니다", comment: "자주 혈당 측정이 필요" },
          { id: 18, location: "p26 복약지도문", text: "현재 하루 1번 복용으로는 효과가 부족할 수 있습니다", comment: "꼭 필요하다면 1일 1회 용법 서방정제제를 요청하세요" },
          { id: 19, location: "p27 맑은이비인후과 자문", text: "위장약 필요 시 영향이 적은 대안을 고려해 주실 수 있을지요", comment: "★ 성분을 명시해 주어도 좋을 것 같다. PCAB(칼륨경쟁적 위산분비 차단제), 케이캡 등" },
          { id: 20, location: "p28 아름다운피부과 자문", text: "표준 용법은 100mg 1일 3회", comment: "1일 2회 복용 서방정 처방도 좋아 보입니다" },
          { id: 21, location: "p29 미래종합병원 자문", text: "현재 1일 1회는 효과가 제한될 수 있습니다", comment: "1회 복용 서방정 처방을 고려" },
      ] },
    ],
  },
  {
    patientId: 1392,
    reportId: 3150,
    label: "환자 4",
    content: `<badge>💊 약 복용 시 특히 주의해야 할 점</badge>
# 1. 혈전 예방약(엘리퀴스)을 드시는 동안 멍·검은 변·코피 등 출혈 징후가 있으면 알려주세요
- 항응고제는 피가 잘 멎지 않게 하는 약입니다. 멍이 쉽게 들거나 검은색 변, 코피·잇몸출혈이 반복되면 다음 진료에 꼭 말씀해 주세요. 복용을 잊었다면 즉시 1정을 드시고 평소처럼 이어서 드세요.
⑆img_201305918

# 2. 진통이 필요할 때는 가급적 '타이레놀 계열'을 우선 생각해주세요
- 현재 심장·신장 질환과 혈전 예방약을 함께 사용 중이어서, 일반 진통소염제(록소프로펜 등)는 위장출혈과 신장 부담을 늘릴 수 있습니다. 필요할 때는 의사와 상의하여 타이레놀 계열을 사용하시는 것이 좋습니다.
⑆img_199700059

# 3. 어지럽거나 가슴이 두근거릴 때는 천천히 일어나시고, 수분을 충분히 드세요
- 이뇨제(라식스)와 심부전 약(포시가)을 함께 드실 때 탈수·저혈압이 생길 수 있습니다. 라식스는 가능하면 오전에 드시고, 앉았다 일어날 때는 천천히 움직이세요.
⑆img_196400037 ⑆img_201310308

# 4. 변비가 있다면 철분(건강기능식품)은 잠시 쉬고, 처방 철분만 드셔보세요
- 철분을 두 종류 이상 드시면 변비가 심해질 수 있습니다. 물을 자주 드시고 채소·과일 섭취를 늘리면 도움이 됩니다. (필요 시 의사·약사와 상의해 변비약을 사용하세요)
⑆img_200101738

# 5. 렌벨라(인 결합제)는 꼭 '식사와 함께' 삼켜서 드세요
- 이 약은 음식 속 '인'을 잡아주는 약이라 식사 때 드셔야 효과가 있습니다. 다른 약과는 시간을 띄워(1시간 전 또는 3시간 후) 드시면 더 안전합니다.
⑆img_201108203

# 6. 취침 전 신경안정제(로라제팜)는 필요한 날만 최소한으로 드세요
- 졸림·어지러움으로 넘어질 위험이 있습니다. 야간에 화장실 가실 때는 꼭 불을 켜고, 침대에서 천천히 일어나세요.
⑆img_197900543

---

<badge>🏥 A병원 선생님께 약물 복용 현황 안내드립니다</badge>
<blockquote>
선생님 안녕하세요. 환자분의 복약 상담을 도와드리는 약사입니다. 복약 현황 검토 중 참고가 될 사항을 안내드립니다.

환자분은 귀 병원에서 심방세동/심부전 표준 치료(아픽사반, 엔트레스토, 라식스, 비소프로롤, 스피로노락톤, 포시가)를 유지 중이며, B병원에서 록소프로펜·로라제팜·설트랄린, C병원에서 아스피린·철분제·렌벨라를 복용 중입니다. 최근 낙상 1회, 변비를 호소합니다.
</blockquote>

# 1) 항응고제와 항혈소판제 병용 현황 안내드립니다
- 아픽사반(5mg bid)과 아스피린(100mg qd)이 병용되고 있습니다. 병용 시 출혈 위험이 증가하므로(SSRI·NSAID 동시 복용 포함) 아스피린 병용 적응증 유무 확인 부탁드립니다. 필요 시 DOAC 단독 유지가 가능할지 검토를 부탁드립니다.

# 2) 고칼륨혈증 및 탈수 위험 모니터링 공유드립니다
- 엔트레스토+스피로노락톤 병용으로 K+ 상승 위험이 있어 정기적인 전해질/Cr 모니터가 필요합니다. 또한 포시가+라식스 병용으로 탈수/저혈압 위험이 있습니다.
- 참고로 라식스는 오전 복용하도록 교육하였습니다.

# 3) 아픽사반 용량 관련 신기능 확인 요청드립니다
- 중증 신장애(CrCl 15–29 mL/min)에서는 2.5mg bid 권고로 기재되어 있어, eGFR/CrCl 확인 후 용량 적정 여부 검토 부탁드립니다(현재 83세, 65kg).

감사합니다. 환자분의 안전하고 효과적인 복용을 위해 선생님의 검토 부탁드립니다.

**다제약물관리 약사 드림**

---

<badge>🏥 B병원 선생님께 약물 복용 현황 안내드립니다</badge>
<blockquote>
선생님 안녕하세요. 환자분 복약 현황을 점검하며 공유드립니다. 환자분은 HF/CKD 동반, A병원에서 DOAC·ARNI·이뇨제·SGLT2·β차단제를 복용 중이며, 최근 낙상과 변비를 호소합니다.
</blockquote>

# 1) 록소프로펜 장기 복용 관련
- 심부전/CKD 및 항응고제·아스피린 동시 복용 상황에서 NSAID 장기 사용은 출혈·신기능 악화 위험이 높습니다. 가능하다면 아세트아미노펜 등으로의 대체를 검토 부탁드립니다.

# 2) 로라제팜(취침 전) 감량/간헐화 여부 문의드립니다
- 낙상 이력이 있고 고령이어서 BDZ 지속 복용은 위해가 커서, 비약물 수면위생 병행 하 감량·간헐 복용 전환이 가능할지 검토 부탁드립니다.

# 3) 메게스트롤 지속 필요성 재평가 요청드립니다
- 메게스트롤은 부신억제/고혈당 등 위험이 있어(라벨 경고) 고령자에서 위해-유익 재평가가 필요해 보입니다. 영양상담·경구영양보충 등 대안도 고려 가능할지 문의드립니다.

감사합니다. 환자분의 안전한 약물 사용을 위해 선생님의 검토 부탁드립니다.

**다제약물관리 약사 드림**

---

<badge>🏥 C병원 선생님께 약물 복용 현황 안내드립니다</badge>
<blockquote>
선생님 안녕하세요. 환자분은 CKD 관련 약물(렌벨라·레날민·철분)을 복용 중이며, 타 기관에서 DOAC(아픽사반) 및 심부전 치료 중입니다.
</blockquote>

# 1) 아스피린 병용 적응증 확인 부탁드립니다
- DOAC(아픽사반)과 아스피린 병용 중입니다. CAD/뇌혈관질환 등 이차예방 적응증이 명확하지 않다면 병용 조정 가능성 검토를 부탁드립니다.

# 2) 철분제·건기식 철분 병용 관련
- 처방 철분(훼로바-유)과 헴철 건기식을 함께 복용 중으로 변비 호소가 있어, 총 투여량 감량 및 건기식 중단을 교육하였습니다. 처방 철분 용량/기간 재평가도 부탁드립니다.

# 3) 렌벨라 복약이행
- 식사와 함께 복용/정제 분쇄 금지/다른 약과 간격 유지 교육을 시행하였습니다.

검토 감사드립니다.

**다제약물관리 약사 드림**`,
    reviewers: [
      {
        label: "A",
        name: "A 약사님",
        affiliation: "",
        comments: [
          { id: 1, location: "p.3 복약지도문", text: "수분을 충분히 드세요", comment: "심부전 환자에서는 수분을 충분히 복용하라는 말이 위험할 수 있음. 탈수 증상 모니터링하고, 의사 지시에 따라 수분 섭취 권장. 이뇨제 사용 환자에서는 체중 모니터링?" },
          { id: 2, location: "p.7 B병원 자문", text: "간헐화 여부", comment: "문구? 간헐화 여부?" },
          { id: 3, location: "p.7 B병원 자문", text: "부신억제/고혈당", comment: "혈전도 포함되어야" },
        ],
      },
      {
        label: "B",
        name: "B 약사님",
        affiliation: "",
        comments: [
          { id: 23, location: "p36", text: "로라제팜(취침 전)", comment: "현재 환자 우울증+ 식욕저하+ 맥박불안정 상태를 고려하여 아티반 + 졸로푸트(SSRI) → 브린텔릭스(Vortioxetine)나 스타브론(Tianeptine)으로 처방 변경 제안드리며, 이후 식욕저하 문제가 개선되면 메게스트롤 또한 처방 중단하실 수 있을 것으로 생각됩니다" },
          { id: 24, location: "p36", text: "메게스트롤 지속 필요성 재평가 요청드립니다", comment: "★ 비보험으로 식욕저하를 겪는 노인에 사용하는 경우가 꽤 많아서 어떻게 제안할지 항상 고민되던 부분입니다" },
        ],
      },
      {
        label: "C",
        name: "C 약사님",
        affiliation: "",
        comments: [
          { id: 16, location: "p33", text: "다른 약과는 시간을 띄워(1시간 전 또는 3시간 후) 드시면 더 안전합니다.", comment: "세벨라머탄산염이 모든 약과 시간을 띄워 먹어야 하는 것은 아니고, 1일3회이므로 복약이행도 측면에서도 다른 약과 시간을 띄워야 한다는 정보는 과도한 정보로 보입니다" },
        ],
      },
      { label: "D", name: "", affiliation: "", comments: [] },
      { label: "E", name: "E 약사님", affiliation: "", comments: [
          { id: 22, location: "p33 복약지도문", text: "변비가 있다면 철분(건강기능식품)은 잠시 쉬고, 처방 철분만 드셔보세요", comment: "철분함량 높으면 변비가 심함. 헴철이 변비가 덜 생기는 경우가 많음" },
          { id: 23, location: "p35 A병원 자문", text: "항응고제와 항혈소판제 병용 현황 안내드립니다", comment: "빼기(−)" },
          { id: 24, location: "p36 B병원 자문", text: "메게스트롤 지속 필요성 재평가 요청드립니다", comment: "★ 빼기(−)" },
      ] },
    ],
  },
];
